import { PageViewEventLogger } from '@repo/tracking-service';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import ResultSelectAuthContent from '@/components/tax-refund/result/SelectAuth/ResultSelectAuthContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const ResultSelectAuthPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증타입선택, 'indis-talk-decision_selectauth_cx');

  return (
    <Layout rightTextButton={rightInquiryButton}>
      <ResultSelectAuthContent />
      <PageViewEventLogger pageName={'indis-talk-decision_selectauth'} />
    </Layout>
  );
};

export default ResultSelectAuthPage;
